import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { CatalogsMatcherTaskState } from './state';

const defaultState: CatalogsMatcherTaskState = {
  tasks: [],
};

export const catalogsMatcherTaskModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
